
import createState from "../request-state";
const state = createState();

import createGetters from "../request-getters";
const getters = createGetters("know-request");

import createActions from "../request-actions";
const actions = createActions("know-requests");

import createMutations from "../request-mutations";
const mutations = createMutations("request-to-know");

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations
}